import { render, staticRenderFns } from "./aCarDetailFee.vue?vue&type=template&id=1918a28d&scoped=true"
import script from "./aCarDetailFee.vue?vue&type=script&lang=js"
export * from "./aCarDetailFee.vue?vue&type=script&lang=js"
import style0 from "./aCarDetailFee.vue?vue&type=style&index=0&id=1918a28d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_29ccf6a1548590c1291b44f0faebdb79/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1918a28d",
  null
  
)

export default component.exports